// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__oKo1T","headerDesktop":"Header_headerDesktop__4MycL","headerMobile":"Header_headerMobile__FXVPf","skip":"Header_skip__uz_Zu"};